import React, { useState } from "react";
import { Breadcrumb } from "antd";
import { useSelector, connect } from "react-redux";
import ServiceList from "./ServiceList";
import CreateNewService from "./CreateNewService";

const Service = ({ auth }) => {
  // const [reload, setReload] = useState(false);
  // const auth = useSelector((state) => state.auth);
  const [updatelist, setUpdatelist] = useState(true);

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>CRM</Breadcrumb.Item>
        <Breadcrumb.Item>Service</Breadcrumb.Item>
      </Breadcrumb>

      <div className="site-layout-background main-frame">
        {auth.permissions.includes("Contacts.Service_is_create") && (
          <CreateNewService
            setUpdatelist={setUpdatelist}
            updatelist={updatelist}
          />
        )}
        <ServiceList
          updatelist={updatelist}
          setUpdatelist={setUpdatelist}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(Service);
